import { useState, useEffect, useContext } from 'react';
import { Language } from '../../../App';

const useWebinarButtonText = (value, user_id) => {
    const {lang} = useContext(Language)
  const [buttonText, setButtonText] = useState('');
   
  useEffect(() => {
    const resolvedUserId =
      user_id ||
      (() => {
        try {
          return JSON.parse(localStorage.getItem("SignupData"))?.data?.id;
        } catch (e) {
          return null;
        }
      })();

    const isCreator =
      (value?.user?.id && resolvedUserId && String(value.user.id) === String(resolvedUserId)) ||
      (value?.user_id && resolvedUserId && String(value.user_id) === String(resolvedUserId)) ||
      Boolean(value?.is_creator || value?.isCreator || value?.is_owner);

    const isHost = Boolean(value?.isHost || value?.is_host || value?.host) || isCreator;

    const rawStatus = value?.status;
    const isLive =
      rawStatus === 1 ||
      rawStatus === "1" ||
      rawStatus === "started" ||
      rawStatus === "live" ||
      rawStatus === "in_progress" ||
      Boolean(value?.is_live || value?.isLive);

    const isEnded =
      rawStatus === 2 ||
      rawStatus === "2" ||
      rawStatus === "ended" ||
      rawStatus === "completed";

    const isReserve = Boolean(
      value?.isReserve ||
      value?.is_reserved ||
      value?.isJoined ||
      value?.is_joined
    );

    if (isEnded) {
      setButtonText(lang?.webinar_ended || "Webinar Ended");
    } else if (isCreator) {
      if (isLive) {
        setButtonText(lang?.start_webinar || "Start Webinar");
      } else {
        setButtonText(lang?.edit_webinar || "Edit Webinar");
      }
    } else if (isHost) {
      setButtonText(lang?.join_as_a_host || lang?.join_as_host || "Join as a host");
    } else {
      if (isLive) {
        setButtonText(lang?.join_webinar || lang?.join_live_webinar || "Join Webinar");
      } else {
        setButtonText(isReserve ? (lang?.unreserve || "Unreserve") : (lang?.reserve_seat || "Reserve Seat"));
      }
    }
  }, [value, user_id, lang]);

  return buttonText;
};

export default useWebinarButtonText;
